import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useDropzone } from 'react-dropzone';
import { IMAGE_MAX_SIZE } from '../../config';
import { toast } from 'react-toastify';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  border: 2px dashed rgba(50, 58, 70, 0.3);
  outline: none;
  .dz-message {
    width: 100%;
    margin: 0 !important;
    height: 100%;
  }
  .dz-initial-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    padding: 0 10px;
    height: 100%;
  }
  .fe-upload {
    font-size: 23px;
    color: #bdbec0;
  }
  .dz-description {
    margin: 0 !important;
  }
  @media (max-width: 960px) {
    .dz-description {
      display: none;
    }
  }
`;

const DropZone = (props) => {
  const {
    handleFileDrop,
    showDescription = true,
    isSingle = false,
    isUploading = false,
    dropzoneDescription = 'Перетащите сюда файлы или кликните для их выбора',
    accept = ['.jpg', '.jpeg', '.png'],
    maxSize = IMAGE_MAX_SIZE,
  } = props;

  const { t } = useAutoTranslation();

  const checkFileTypeMatch = (file) => !accept || accept.some((elem) => file.name.endsWith(elem));

  const onDropAccepted = (acceptedFiles) => {
    if (!isFileTooLarge) {
      handleFileDrop(acceptedFiles);
    }
  };

  const onDrop = (accepted, rejected) => {
    if (!rejected.length) return;
    const message = [];
    if (accepted.length && rejected.length) {
      message.push(t(`Загружены не все файлы`));
    } else if (rejected.length) {
      message.push(t(`Файлы не загружены`));
    } else {
      message.push(t(`Файл на загружен`));
    }
    if (rejected.some((f) => f.size > maxSize)) {
      message.push(`${t('Максимальный размер файла')} ${maxSize / 1024 / 1024} мб.`);
    }
    if (rejected.some((f) => !checkFileTypeMatch(f))) {
      message.push(t(`Присутствуют файлы невалидного формата`));
    }
    toast.error(message.join(` `));
  };

  const { getRootProps, getInputProps, rejectedFiles } = useDropzone({
    onDropAccepted,
    onDrop,
    multiple: !Boolean(isSingle),
    accept,
    maxSize,
  });

  const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize;

  return (
    <Wrapper {...getRootProps()} className={`dropzone ${showDescription ? 'with-text' : ''}`}>
      <div className="dz-message needsclick">
        <div className="dz-initial-wrapper">
          {!isUploading ? (
            <Fragment>
              <i className="fe-upload" />
              {showDescription ? <p className="dz-description">{t(dropzoneDescription)}</p> : null}
            </Fragment>
          ) : (
            <div className="spinner-border text-primary" role="status" />
          )}
        </div>
        <input {...getInputProps()} />
      </div>
    </Wrapper>
  );
};

export default DropZone;
